import React from 'react'
const ItemEditIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.22192 4.17638L3.76562 9.63281V12.5495H6.68229L12.1386 7.09302C12.5942 6.63741 12.5942 5.89873 12.1386 5.44312L10.8718 4.17637C10.4162 3.72075 9.67753 3.72076 9.22192 4.17638Z"
      stroke="black"
      strokeWidth="1.5"
    />
  </svg>
)
export default ItemEditIcon
